import { useContext, useMemo } from 'react';
import { SiteContext } from '../../contexts/Site/SiteContext';
import { ModalLink } from './ModalLink';
import bandPhoto from '../../images/nett-live.jpeg';
import { LazyImage } from '../lazy-image';
import { menus } from '../../contexts/Site';
export const NettInfo = () => {
  const bandcampLink = 'https://nettnyc.bandcamp.com';
  const spotifyLink =
    'https://open.spotify.com/track/7H2l822LVtVHQjRVZ1zZHS?si=e35684ede2f24492';
  const {
    isMobileView,
    colorTheme: { accentColor },
    setCurrentMenu,
  } = useContext(SiteContext);

  const instagramLink = 'https://instagram.com/nett.nyc';
  const mailtoLink = 'mailto:booking@nett.nyc';

  const imageWidth = isMobileView ? '240px' : '290px';

  const valVidLink = "https://www.youtube.com/embed/S2dFbYzhmXQ?si=Y8uW83tUvXHchBTy"
  const spLink = "https://www.youtube.com/embed/ICOsWl5tjBg?si=uvJfUWo_bxeU-xQE"

  const kstonevidlink = "https://www.youtube.com/embed/KpFCxn-YYUU"
  const ytFrame = useMemo(() => {
    return <iframe width={isMobileView ? '240' : '290'} height={isMobileView ? '135' : '163'} src={kstonevidlink} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" style={{ borderRadius: '10%', width: imageWidth, maxWidth: '100%' }}
            allowfullscreen></iframe>
  }, []);

 
  const kstone = "https://www.youtube.com/watch?v=KpFCxn-YYUU"

  
  const woodShopLink = "https://youtu.be/qE2Rjp4MJb4"
  const eventLink = "https://www.prekindle.com/event/86598-halloween-on-the-mary-whalen-brooklyn"
  const valentinesLink = "/valentines"

  const berlinLink = "https://www.ticketweb.com/event/investigation-freedom-attic-berlin-tickets/14130444?pl=berlin"
  const imageStyle = {
    // border: `solid ${accentColor} 5px`,
    borderRadius: '10%',
    zIndex: 999,
  };

  return (
    <div>
      <p style={{ marginBottom: '12px' }}>
        <span style={{ fontFamily: 'Karrik-Italic' }}>Nett</span> is an
        experimental rock band based in New York City.
      </p>
      <div>
        <div style={{ marginBottom: '16px' }}>
          {ytFrame}
          {/* <iframe
            width={isMobileView ? '240' : '290'}
            height={isMobileView ? '135' : '163'}
            src="https://www.youtube.com/embed/78u7SlouRgY"
            title="Nett - Solstice 2025 Edit"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            style={{ borderRadius: '10%', width: imageWidth, maxWidth: '100%' }}
          ></iframe> */}
        </div>
        {/* <img
          width={imageWidth}
          style={imageStyle}
          height="auto"
          src={bandPhoto}
        /> */}
      </div>
      <div style={{ color: accentColor, marginTop: '5px' }}>
        <p>
          &#x279F;{' '}
          <ModalLink
            href={bandcampLink}
            color={accentColor}
            text={'Bandcamp'}
            includeIcon={false}
          />
        </p>
        <p>
          &#x279F;{' '}
          <ModalLink
            href={spotifyLink}
            color={accentColor}
            text={'Spotify'}
            includeIcon={false}
          />
        </p>
        <p>
          &#x279F;{' '}
          <ModalLink
            href={instagramLink}
            color={accentColor}
            text={'Instagram'}
            includeIcon={false}
          />
        </p>
        <p>
          &#x279F;{' '}
          <ModalLink
            href={mailtoLink}
            color={accentColor}
            text="Email"
            icon="mail"
            includeIcon={false}
          />
        </p>
          {/* <p>
          &#x279F;{' '}
          <ModalLink
            href={kstone}
            color={accentColor}
            text="Live at Keystone"
            includeIcon={false}
          />
        </p> */}
        
        {/* <p>
          &#x279F;{' '}
          <ModalLink
            color={accentColor}
            text={'Live Shows'}
            includeIcon={false}
            onClick={() => setCurrentMenu(menus.shows)}
          />
        </p> */}
      </div>
    </div>
  );
};
